<template>
    <section class="content">
        <div class="container-fluid">
            <loader v-show="loading" :type="'monitor'"/>
            <div v-if="!loading && $gate.hasActiveSubscription()" class="sticky-top info-bar">
                <div style="margin-top: -2rem; margin-left: -10.5rem;">
                    <stock-ticker />
                </div>
                <div style="padding-bottom: 0.1rem">
                    <news-reel />
                </div>
            </div>
            <div v-if="!loading_social_searchers && social_searchers.length">
                <div class="row" v-for="(social_searcher, index) in social_searchers" :key="'dashboard-social-searcher-'+social_searcher.id">
                    <div v-if="main_feeds[index] !== undefined" class="col-12 col-md-4 col-lg-6 col-xl-3">
                        <feed :feed="main_feeds[index]" :is_main="true" />
                    </div>
                    <div :class="main_feeds[index] !== undefined ? 'col-12 col-md-8 col-lg-6 col-xl-9' : 'col-12'">
                        <social-searcher :social_searcher="social_searcher" :main_feed_id="main_feeds[index] !== undefined ? main_feeds[index].id : '' " />
                    </div>
                </div>
                <hr>
            </div>
            <div v-if="!loading_feeds">
                <div class="row" v-if="feeds.length || $gate.hasFeaturePermission('personal_news')">
                    <div class="col-12">
                        <h1>{{translate('messages.feeds')}}</h1>
                    </div>
                </div>
                <div class="row">
                    <div v-if="$gate.hasFeaturePermission('personal_news')" class="col-12 col-sm-6 col-lg-4 col-xl-6">
                        <personal-news />
                    </div>
                    <div v-for="feed in feeds" :key="'dashboard-feed-'+feed.id" class="col-12 col-sm-6 col-lg-4 col-xl-3">
                        <feed :feed="feed" />
                    </div>
                </div>
                <hr>
            </div>
            <div v-if="!loading_chamber_searches && ($gate.hasFeaturePermission('mx_chamber') || $gate.isType(['admin', 'editor']))">
                <div class="row">
                    <div class="col-12">
                        <h1>{{translate('messages.chamber_searches')}}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <chamber-today />
                    </div>
                </div>
                <div class="row">
                    <div v-for="chamber_search in chamber_searches" :key="'dashboard-chamber-search-'+chamber_search.id" class="col-12 col-sm-6 col-lg-4">
                        <chamber-search :chamber_search="chamber_search" />
                    </div>
                </div>
                <hr>
            </div>
            <div v-if="!loading_social_timelines && social_timelines.length">
                <div class="row">
                    <div class="col-12">
                        <h1>{{translate('messages.social_timelines')}}</h1>
                    </div>
                </div>
                <div class="row">
                    <div v-for="social_timeline in social_timelines" :key="'dashbord-social-timeline-'+social_timeline.id" class="col-12 col-sm-6 col-lg-4">
                        <social-timeline :social_timeline="social_timeline" />
                    </div>
                </div>
            </div>
            <div class="row mt-2" v-if="emptyMonitor">
                <div class="col-12 text-center">
                    <img class="img-fluid" src="images/logo.png" alt="logo Monitor de Noticias" style="max-width: 300px;">
                    <h1 class="pt-3">{{translate('messages.empty_monitor')}}</h1>
                    <router-link v-if="$gate.hasFeaturePermission('markers')" to="/markers" class="btn btn-secondary m-3">
                        {{translate('messages.add')}} {{translate('messages.markers')}}
                    </router-link>
                    <router-link v-if="$gate.hasFeaturePermission('feeds')" to="/feeds" class="btn btn-secondary m-3">
                        {{translate('messages.add')}} {{translate('messages.feeds')}}
                    </router-link>
                    <router-link v-if="$gate.hasFeaturePermission('social_timelines')" to="/social_timelines" class="btn btn-secondary m-3">
                        {{translate('messages.add')}} {{translate('messages.social_timelines')}}
                    </router-link>
                    <router-link v-if="$gate.hasFeaturePermission('social_searchers')" to="/social_searchers" class="btn btn-secondary m-3">
                        {{translate('messages.add')}} {{translate('messages.social_searchers')}}
                    </router-link>
                </div>
            </div>
            <div v-if="!$gate.hasActiveSubscription()">
                <no-subscription></no-subscription>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data () {
            return {
                feeds : [],
                loading_feeds : true,
                social_timelines : [],
                loading_social_timelines : true,
                social_searchers: [],
                loading_social_searchers : true,
                main_feeds : [],
                chamber_searches: [],
                loading_chamber_searches : true,
            }
        },
        methods: {
            loadFeeds(){
                if(!this.$gate.hasFeaturePermission('feeds')){
                    this.loading_feeds = false;
                    return;
                }
                axios.get('/api/feed/all').then(({ data }) => {
                    this.loading_feeds = false;
                    let feeds = data.data;
                    if(this.$gate.hasFeaturePermission('social_searchers')){
                        let main_feeds = [];
                        var v = this;
                        this.getSocialSearchersLength().then(function(social_searchers_length){
                            for (let i = 0; i < social_searchers_length; i++){
                                main_feeds.push(feeds.shift());
                            }
                            v.feeds = feeds;
                            v.main_feeds = main_feeds;
                            v.loading_feeds = false;
                        })
                    }else{
                        this.feeds = feeds;
                        this.loading_feeds = false;
                    }
                });
            },
            getSocialSearchersLength(){
                var v = this;
                var promise = new Promise(function(resolve, reject) {
                    window.setTimeout(function() {
                        resolve(v.loading_social_searchers);
                    }, 300);
                }).then(function(loading_social_searchers){
                    return !loading_social_searchers ? v.social_searchers.length : v.getSocialSearchersLength()
                });
                return promise;
            },
            loadSocialTimelines(){
                if(!this.$gate.hasFeaturePermission('social_timelines')) {
                    this.loading_social_timelines = false;
                    return;
                }
                axios.get('/api/socialTimeline/all').then(({ data }) => {
                    this.loading_social_timelines = false;
                    this.social_timelines = data.data;
                });
            },
            loadSocialSearchers(){
                if(!this.$gate.hasFeaturePermission('social_searchers')){
                    this.loading_social_searchers = false;
                    return;
                }
                axios.get('/api/socialSearcher/all').then(({ data }) => {
                    this.loading_social_searchers = false;
                    this.social_searchers = data.data;
                });
            },
            loadChamberSearches(){
                if(this.$gate.isType('user') && !this.$gate.hasFeaturePermission('mx_chamber')){
                    this.loading_chamber_searches = false;
                    return;
                }
                axios.get('/api/chamberSearch/all').then(({ data }) => {
                    this.loading_chamber_searches = false;
                    this.chamber_searches = data.data;
                });
            },
        },
        mounted() {
          
        },
        created() {
            this.loadFeeds();
            this.loadSocialSearchers();
            this.loadSocialTimelines();
            this.loadChamberSearches();
        },
        computed: {
            loading: function () {
                return this.loading_feeds && this.loading_social_timelines && this.loading_social_searchers && this.loading_chamber_searches;
            },
            emptyMonitor: function () {
                return this.$gate.hasActiveSubscription() && (!this.loading_feeds && !this.feeds.length) && (!this.loading_social_timelines && !this.social_timelines.length) && (!this.loading_social_searchers  && !this.social_searchers.length);
            }
        }
    }
</script>
